/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/11/2021
 */

import { initializeApp } from "firebase/app"

export default class FirebaseWrapper {

	firebaseApp

	authWrapper
	firestoreWrapper
	storageWrapper

	constructor(config) {
		this.firebaseApp = initializeApp(config)
	}

	firestore(){
		return this.firestoreWrapper
	}

	storage(){
		return this.storageWrapper
	}

	auth(){
		return this.authWrapper
	}
}
